<template>
    <section class="about-profile content-section container px-3">
        <h2 class="content-section-title">COMPANY PROFILE</h2>
        <b-row class="justify-start">
            <b-col cols='12' class="table-responsive mb-0">
                <table>
                    <tr
                        v-for="(detail,i) in details"
                        :key="i"
                    >
                        <th>{{detail.title}}</th>
                        <td>{{detail.content}}</td>
                    </tr>
                </table>
            </b-col>
        </b-row>
    </section>
</template>

<script>
export default {
    data() {
        return {
            details:[
                {title: 'Company Name', content: 'ScanTop Enterprise Co., Ltd.'},
                {title: 'Company Address', content: '22F-2, No.33, Sec.1, Minsheng Rd., Banqiao Dist., New Taipei City 22069, Taiwan'},
                {title: 'Company Phone Number', content: '+886-2-2957-3478'},
                {title: 'Company Fax Number', content: '+886-2-2957-3288'},
                {title: 'Plant Location', content: 'Dachengqiao Industrial Park, Jiepai Town, Danyang City, Jiangsu, China'},
                {title: 'Established Date', content: '1991'},
                {title: 'The Number of Employee', content: '500'},
                {title: 'Plant Size', content: '48,000 Square Meter ( Roughly 520,000 Square Feet )'},
                {title: 'Production Capacity', content: '5.0 million units per month'},
                {title: 'Shipping Port', content: 'Shanghai, China'},
                {title: 'Type of Business', content: 'Exporter, Manufacturer'},
                {title: 'Own Brands', content: 'ViewGuard、BestGuard'},
                {title: 'Certification', content: 'BSCI、IATF 16949 : 2016'},
            ]
        }
    },
}
</script>

<style lang="scss">
    .about-profile {
        table{
            margin: 0 auto;
            font-size: 14px;
            border: 1px solid $color-main;
            th,td{
                padding: 5px 20px;
            }
            th{
                width: auto;
                font-weight: bold;
                background-color: rgba(246,252,255,1);
            }
            
            @media (min-width:992px){
                th{
                    width: 300px;
                }
            }
        }
    }
</style>